module.exports = __webpack_public_path__ + "static/media/FFEP_221228.092bf1ec.jpg";